import React from 'react';
import { Box, Button } from '@mui/material';
import { useFormikContext } from 'formik';
import ConfirmDeleteComponent from '../../../components/ConfirmDeleteComponent';

interface ActionButtonsComponentProps {
    isUpdating: boolean
    isCreateOperation: boolean;
    isDeleting: boolean;
    deleteStore: () => void;
    storeName: string;
}

const ActionButtonsComponent: React.FC<ActionButtonsComponentProps> = ({
    isUpdating,
    isCreateOperation,
    isDeleting,
    deleteStore,
    storeName
}) => {
    const { isValid } = useFormikContext<any>();

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 2 }}>
            <Button variant="contained" type="submit" disabled={!isValid || isUpdating} sx={{height: 'fit-content'}} >
                {isUpdating ? "Saving.." : "Save Changes"}
            </Button>
            {!isCreateOperation && (
                <ConfirmDeleteComponent
                    onConfirmDelete={deleteStore}
                    confirmationText={storeName}
                    isDeleting={isDeleting}
                />
            )}
        </Box>
    );
};

export default ActionButtonsComponent;
